import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { FormValidationCheckerService } from '../_shared/services/form-validation-checker.service';
import { CommonModule } from '@angular/common';
import { LabelComponent } from '../label/label.component';

@Component({
    selector: 'sirius-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, LabelComponent]
})
export class CheckboxComponent implements ControlValueAccessor, OnInit {
    private _ngControl = inject(NgControl, { optional: true, self: true });
    validationService = inject(FormValidationCheckerService, { optional: true });

    @Input() checked = false;
    @Input() label = '';
    @Input() id = '';
    @Input() name = '';
    @Input() identifier = '';

    private _valid = new BehaviorSubject<boolean>(true);
    valid$ = this._valid.asObservable();

    private _value?: string;

    get control() {
        return this._ngControl?.control as FormControl;
    }

    onChangeCallback: (value: string | boolean | undefined) => void = () => {
        //empty
    };

    onTouchedCallback = () => {
        //empty
    };

    constructor() {
        if (this._ngControl) this._ngControl.valueAccessor = this;
    }

    ngOnInit(): void {
        this.updateModel();

        this.control.statusChanges.subscribe((status) => {
            this._valid.next(status !== 'INVALID' ? true : false);
        });
    }

    onChange(e: Event): void {
        this.checked = (e.target as HTMLInputElement).checked;
        this.updateModel();
    }

    protected updateModel() {
        this.onChangeCallback(this.checked ? this._value : undefined);
    }

    writeValue(value: unknown) {
        this._value = `${value}` || 'on';
    }

    registerOnChange(fn: (value: string | boolean | undefined) => void): void {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouchedCallback = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        if (isDisabled) this.control?.disable();
    }
}
